import React, { memo } from "react";

const AppEmailTemplatesIcon = ({ color = "#ffffff", ...props }) => {
	return (
		<svg {...props} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M20,4H4C2.9,4,2.01,4.9,2.01,6L2,18c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,8l-8,5L4,8V6l8,5l8-5V8z"
				fill={color}
			/>
		</svg>
	);
};

export default memo(AppEmailTemplatesIcon);
